/**
 * Mutable flag shared between the floating style editor (sets it while a
 * handle drag is in progress) and EditableContent (whose hover-open must not
 * re-anchor the editor mid-drag — that made the overlay "vanish" onto whatever
 * field the pointer crossed while stretching). Event handlers read it
 * synchronously, so plain module state is enough — no React reactivity needed.
 */
export const editorDrag = { active: false };
